import * as React from 'react'
import { AbTestData } from '@/scopes/common/infrastructure/ab-testing/edge-function/types'

export const AbTestContext = React.createContext<AbTestData>({
  isEnabled: false,
  isBVariant: false,
})

export const useAbTestContext = () => React.use(AbTestContext)
